import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Table, ZeroState, NotifPref, MessagePopover } from 'ecs-react-components/dist/index.es';
import { messages } from './FollowUpPlan.i18n';
import { columns } from './FollowUpPlanGridConfig';
import { loadFollowUpPlan, loadPatientNotifyPreference } from '../../redux/modules/follow-up/middleware';
import * as mapper from '../../redux/modules/follow-up/mapper';
import { auditRequest } from '../../redux/modules/audit/audit-middleware';
import { configPlanDetails, configFilter } from './FollowUpPlanConfig';
import FilterButtonGroup from '../../components/Filter/FilterButtonGroup';
import { setUserPreference } from '../../redux/modules/user-profile/user-profile-middleware';
import Header from '../../components/Header/Header';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

const FOLLOWUP_PLAN_VIEW_AUDIT_TYPE = 'followupplanviewauditevent';

class FollowUpPlan extends React.Component {
  componentDidMount() {
    const {
      patientId,
      dispatch,
    } = this.props;

    if (patientId) {
      dispatch(auditRequest(FOLLOWUP_PLAN_VIEW_AUDIT_TYPE, patientId));
      dispatch(loadPatientNotifyPreference(patientId));
      dispatch(callWithLoadingIndicator(
        'FollowUpPlan', () => this.props.dispatch(loadFollowUpPlan(patientId))));
    }
  }

  handleClickEvent = (filterValue) => {
    if (!filterValue || filterValue.length === 0) {
      return;
    }
    this.props.dispatch(
      setUserPreference(
        'PatientPortal_FollowupPlanFilter_Date',
        filterValue));
  }

  render() {
    const config = {
      columns: columns(messages,
        this.props.timeZone,
        this.props.followUpPlan ? this.props.followUpPlan.taskNames : null),
      store: this.context.store,
    };

    let appointments = [];
    let planDetailsConfigInfo;

    if (this.props.followUpPlan) {
      const followUpPlan = mapper.mapFollowUpPlan(this.props.followUpPlan, this.props.language);

      (({ appointments } = followUpPlan));

      appointments = this.props.filter === 'Upcoming'
        ? appointments.filter((current) => current.isUpcoming)
        : appointments;

      if (followUpPlan.templates && followUpPlan.templates.length > 0) {
        planDetailsConfigInfo = configPlanDetails(followUpPlan);
      }
    }
    return (
      <div id="followup-plan-content">
        <div className="row">
          <div className="col-xs-12">
            <div className="top-right-utility-buttons">
              {
                planDetailsConfigInfo
                  ? <MessagePopover { ...planDetailsConfigInfo } />
                  : null
              }
            </div>
            <Header headerTitle={ <FormattedMessage { ...messages.page.title } /> } />
            <div className="spacer tiny"></div>
            <div className="spacer small"></div>
            <LoadingIndicatorContainer loadingKey="FollowUpPlan" >
              <div className="row">
                <div className="form-group col-md-3 col-sm-4 col-xs-6">
                  <FilterButtonGroup
                    handleClickEvent={ this.handleClickEvent }
                    { ...configFilter(this.props.filter) }
                  />
                </div>
              </div>
              <div className="spacer small"></div>
              {
                appointments.length > 0 ?
                  (
                  <div data-qa-item="planContent">
                    <div className="table-responsive">
                      <Table
                        columns={ config.columns }
                        data={ appointments }
                        notReversed
                        customExpansion
                      />
                    </div>
                    <h6 data-qa-item="notifPref">
                      <FormattedMessage
                        { ...messages.statements.preference }
                        values={{
                          patientNotifPref:
                          <NotifPref
                            fieldName={ <FormattedMessage { ...messages.notifPreference.FieldName } /> }
                            patientNotifPreference={ this.props.patientNotifyPreference }
                          />,
                        }}
                      />
                    </h6>
                    <h6 data-qa-item="timeZoneWarning">
                      <FormattedMessage
                        { ...messages.statements.timezone }
                        values={{ facilityTimeZone: this.props.timeZone }}
                      />
                    </h6>
                  </div>
                  ) :
                  (
                    <ZeroState
                      zeroStateMessage={
                        <FormattedMessage { ...messages.page.zeroState } />
                      }
                      stateIconCss="ion ion-navigate"
                    />
                  )
              }
            </LoadingIndicatorContainer>
          </div>
        </div>
      </div>
    );
  }
}

FollowUpPlan.propTypes = {
  dispatch: PropTypes.func,
  followUpPlan: PropTypes.object,
  filter: PropTypes.string,
  patientId: PropTypes.number,
  timeZone: PropTypes.string,
  language: PropTypes.string,
  patientNotifyPreference: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

const mapStateToProps = (state) => ({
  followUpPlan: state.followUp.followUpPlan,
  filter: state.profile.user.preferences.PatientPortal_FollowupPlanFilter_Date,
  patientId: state.profile.patient.patientId,
  timeZone: state.facility.timeZoneAbbreviation,
  language: state.language.languageCode,
  patientNotifyPreference: state.followUp.patientNotifyPreference,
});


export default connect(mapStateToProps)(FollowUpPlan);